import { Route, Routes } from 'react-router-dom';
import { DepartmentsPage } from './pages/DepartmentsPage';
import { DepartmentDetailPage } from './pages/DepartmentDetailPage';

export const DepartmentRoutes = () => {
  return (
    <Routes>
      <Route index element={<DepartmentsPage />} />
      <Route path="new" element={<DepartmentsPage />} />
      <Route path=":id" element={<DepartmentDetailPage />} />
      <Route path=":id/edit" element={<DepartmentsPage />} />
    </Routes>
  );
};

export default DepartmentRoutes;
